import styled from 'styled-components';

export const StyledNotificationDivWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
    background: ${({ theme }) => theme.color.white};
    border-top: 0.1rem solid ${({ theme }) => theme.color.grey4};

    @media screen and (min-width: ${({ theme }) =>
            theme.deprecatedScreen.tabletLandscapeMinimum}) {
        position: absolute;
        top: 4.4rem;
        right: 0;
        left: auto;
        min-width: 29rem;
        height: 40rem;
        border: 0.1rem solid ${({ theme }) => theme.color.grey5};
        border-radius: ${({ theme }) => theme.borderRadius.default};
        box-shadow: ${({ theme }) => theme.shadow.high};

        && button {
            border: none;
        }

        && li {
            border-top: none;
            border-right: none;
            border-bottom: 0.1rem solid ${({ theme }) => theme.color.grey4};
            border-left: none;
        }

        && li:last-child {
            border-bottom: none;
        }
    }
`;

export const StyledNotificationsUlContainer = styled.ul`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    padding: 0;
    overflow-x: hidden;
    overflow-y: auto;
    list-style: none;

    @media screen and (min-width: ${({ theme }) =>
            theme.deprecatedScreen.tabletLandscapeMinimum}) {
        height: 40rem;
        overflow-x: hidden;
        overflow-y: auto;
        border: none;
        border-bottom: 0.1rem solid ${({ theme }) => theme.color.grey4};
    }
`;

export const StyledMobileArrowIconSpan = styled.span`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    min-width: 1.6rem;
    min-height: 1.6rem;
    margin: 0.8rem 0 0.8rem 1.6rem;
    padding: 0;
    background: transparent;
    border: none;
    box-shadow: none;

    @media screen and (min-width: ${({ theme }) =>
            theme.deprecatedScreen.tabletLandscapeMinimum}) {
        display: none;
    }
`;

export const StyledLabelSpan = styled.span`
    display: flex;
    align-items: center;
    margin-left: 1.6rem;
    color: ${({ theme }) => theme.color.black};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    font-size: ${({ theme }) => theme.font.size.base};
    line-height: 2rem;

    @media screen and (min-width: ${({ theme }) =>
            theme.deprecatedScreen.tabletLandscapeMinimum}) {
        color: ${({ theme }) => theme.color.grey6};
        font-weight: ${({ theme }) => theme.font.weight.bold};
        font-size: ${({ theme }) => theme.font.size.base};
        cursor: initial;
    }
`;

export const StyledLiLabelWrapper = styled.li`
    display: flex;
    flex: 0 0 5.6rem;
    width: 100%;
    border-top: none;
    border-bottom: 0.1rem solid ${({ theme }) => theme.color.grey4};

    @media screen and (min-width: ${({ theme }) =>
            theme.deprecatedScreen.tabletLandscapeMinimum}) {
        border: 0.1rem none solid ${({ theme }) => theme.color.grey5};
    }
`;

export const StyledNotificationArea = styled.span`
    color: ${({ theme }) => theme.color.grey6};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    font-size: ${({ theme }) => theme.font.size.small};
    line-height: 2rem;
    text-transform: capitalize;

    @media screen and (min-width: ${({ theme }) =>
            theme.deprecatedScreen.tabletLandscapeMinimum}) {
        cursor: initial;
    }
`;

export const StyledNotifications = styled.ul`
    padding-left: 0;
    list-style: none;
`;

export const StyledNotification = styled.li`
    display: flex;
    flex-direction: column;
    border-bottom: 0.1rem solid ${({ theme }) => theme.color.grey4};

    a {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 0.8rem 1.6rem;
        color: ${({ theme }) => theme.color.black};
        font-weight: ${({ theme }) => theme.font.weight.bold};
        text-decoration: none;

        &:hover,
        &:focus {
            background-color: ${({ theme }) => theme.color.grey1};
        }
    }
`;

export const StyledNoNotificationsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 29rem;
    height: calc(100vh - 5.6rem);
    margin-right: auto;
    margin-left: auto;

    @media screen and (min-width: ${({ theme }) =>
            theme.deprecatedScreen.tabletLandscapeMinimum}) {
        flex: 1;
    }

    > p {
        font-weight: ${({ theme }) => theme.font.weight.bold};
    }
`;
